import { render, staticRenderFns } from "./DeptInfo.vue?vue&type=template&id=df4624ec"
import script from "./DeptInfo.vue?vue&type=script&lang=js"
export * from "./DeptInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports